import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-237e374e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "iconAndTextWrapper" }
const _hoisted_2 = {
  key: 0,
  class: "icon"
}
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 1,
  class: "body"
}
const _hoisted_5 = { class: "body" }


import CustomPic from "../generics/CustomPic.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextBlock',
  props: {
  headerTag: {
    type: String,
    default: () => "h1",
  },
  header: {
    type: String,
    default: () => "",
  },
  content: {
    type: String,
    default: () => "",
  },
  leadingIcon: {
    String,
    default: () => "",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.leadingIcon != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(CustomPic, {
            auto: true,
            "picture-path": __props.leadingIcon
          }, null, 8, ["picture-path"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (__props.header != '')
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.headerTag), {
            key: 0,
            class: "header"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.header), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.content != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.content), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})